import styled from 'styled-components';
import { Modal } from 'src/components/Modal';

export const LgpdModal = styled(Modal)`
  .modal-body {
    padding: 24px;
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }

  /* footer (Ui.Actions) — a modal LGPD não usa footerContent */
  > *:last-child {
    padding: 16px 24px;
    gap: 8px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  color: ${(props) => props.theme.colors.cardSettingsTextColor};
`;

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DocumentLink = styled.a`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.cartTitleColor};
  text-decoration: underline;

  &:hover {
    opacity: 0.85;
  }
`;
